import React from 'react';
import styles from './Banner.module.css';

import EthanImg from '../media/ethan.png';

const Banner = ({ title, image, custom, background }) => {
    return (
        <div className={styles.banner + " " + (custom ? styles.customBg : "") + " " + (background ? styles.bgImgExtra : "")} style={{ backgroundImage: background ? `url(${background})` : '' }}>
            <div className={styles.bannerContent} style={{ height: background ? '300px' : '' }}>

                {(image || !custom) ? (<img src={image || EthanImg} alt="Banner" className={styles.bannerImage + " " + (image ? styles.customImage : "")} />) : null}
                <h1 className={styles.title}>{title || 'Ethan Freed'}</h1>
                <h2 className={styles.subtitle}>{custom ? "" : "Mechanical Engineering @ UCLA"}</h2>
            </div>
        </div>
    );
};

export default Banner;